<!-- https://www.vue-tailwind.com/docs/select -->
<template>
  <div class="relative">
    <t-select
      id="ce-tracker-course"
      v-model="selectedOption"
      :variant="variant"
      class="p-1 focus:ring-2 focus:outline-none focus:ring-opacity-50"
      :value="selectedOption"
      :disabled="isDisabled"
      @update:model-value="setSelected"
    >
      <t-select-trigger
        :id="elementId + '-trigger'"
        :variant="variant"
        select-icon="chevron-down"
        select-icon-variant="ceTracker"
        :style="triggerValidatedStyle"
      >
        <t-select-value placeholder="State" />
      </t-select-trigger>
      <t-select-content>
        <t-select-item
          v-for="state in states"
          :key="state[valueKey]"
          :value="state[valueKey]"
          class="justify-start"
        >
          {{ state[labelKey] }}
        </t-select-item>
      </t-select-content>
    </t-select>
  </div>
</template>

<script>
import states from '@/data/states.json';

export default {
  name: 'StateOptions',
  props: {
    label: {
      type: String,
      default: 'State',
    },
    value: {
      type: Object,
      default: () => ({}),
    },
    variant: {
      type: String,
      default: 'home',
    },
    labelKey: {
      type: String,
      default: 'id',
    },
    valueKey: {
      type: String,
      default: 'id',
    },
    isDisabled: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
    elementId: {
      type: String,
      default: 'state-options-select',
    },
    modelValue: {
      type: [Object, String],
      default: () => ({}),
    },
    showValidSelection: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['update:modelValue', 'input'],
  setup() {
    const { loggedIn } = useNuxtApp().$auth;

    return { loggedIn };
  },
  data() {
    return {
      states,
      selectedOption: this.modelValue[this.valueKey],
    };
  },

  computed: {
    triggerValidatedStyle() {
      // Apply green styling if there's a selected profession
      return this.showValidSelection && this.selectedOption ? {
        borderColor: 'limegreen',
        backgroundColor: '#e7ffe7',
      } : {};
    },
  },

  watch: {
    modelValue(newState) {
      this.selectedOption = newState[this.valueKey];
    },
  },
  mounted() {
    console.log('state options mounted', this.selectedOption, this.modelValue);
  },
  // This is how the v-model works when using nested components.
  // This is not always needed, but probably if a nested `v-model` is used.
  methods: {
    setSelected(newValue) {
      const state = getLocationState(newValue);
      console.log('state options', state);
      this.$emit('update:modelValue', getLocationState(newValue));
    },
  },
};

// doing this because we want a state object and not just the state abbreviation or the state name.
// we want a full object because we want to do some extra stuff with the data in other location and this
// allows the most dynamic approach.
function getLocationState(newState) {
  const selectedState = states.find(state => state.id === newState || state.name === newState);
  return selectedState && Object.freeze({
    ...selectedState,
    type: 'state',
  });
}
</script>

<style scoped>
label {
  font-weight: bold;
}
</style>
